bam-navigation {
  & bal-nav {
    @include mobile() {
      position: relative;
      z-index: var(--bal-z-index-navigation);
    }
  }
}
// Editmode styles specifically for JobPage Template
.edit-mode {
  .bal-nav-meta-bar-transform {
    top: 30px;
  }
}

// Extra margin for meta nav in case a page note is present in editmode
.has-page-note {
  & .bal-nav-meta-bar-transform {
    position: relative !important;
  }
}
